import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Logo from "../../../assets/images/logo-inner.svg";
import { Formik } from "formik";
import RegisterBanner from "../../../assets/images/register-right-img.png";
import { userSignUp, getStateList } from "../../../services/authService";
import { checkEmailExist } from "../../../services/userService";
import Loader from "../../../components/common/Loader";
import storage from "../../../helpers/storage";
import InputText from "../../../components/common/InputText";
import InputSelect from "../../../components/common/InputSelect";
import InputPhoneMask from "../../../components/common/InputPhoneMask";
import InputPassword from "../../../components/common/InputPassword";
import { LoginSchema } from "../../../validations/Auth";
import { Scrollbars } from "react-custom-scrollbars";
import { SignUpSchema } from "../../../validations/Auth";
import ReCAPTCHA from "react-google-recaptcha";
import { nameBasedRoutes } from "../../../router/public";
import { nameBasedProtectedRoutes } from "../../../router/protected";
import InputMask from "react-input-mask";
import FormHelperText from "@mui/material/FormHelperText";
import { toast } from "react-toastify";
import { MESSAGES } from "../../../constants/messages";

export const Register = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [isCheckedBilling, setIsCheckedBilling] = useState(false);
  const [isCheckedDecal, setIsCheckedDecal] = useState(false);
  const [disableBilling, setDisableBilling] = useState(false);
  const [disableYard, setDisableYard] = useState(false);
  const [disableDecal, setDisableDecal] = useState(false);
  const [step1, setStep1] = useState(true);
  const [step2, setStep2] = useState(false);
  const [step3, setStep3] = useState(false);
  const [captchaCode, setCaptchaCode] = useState("");
  const [states, setStates] = useState([]);

  const rememberMe: any = storage.getData("remember-me");
  const initialValues = {
    first_name: "",
    last_name: "",
    email: "",
    company_name: "",
    phone: "",
    cell_number: "",
    address: "",
    role: "CUSTOMER",
    city: "",
    state: "",
    zip_code: "",
    password: "",
    confirm_password: "",
    billing_contact_name: "",
    billing_contact_email: "",
    billing_cell_number: "",
    billing_address: "",
    billing_state: "",
    billing_zip: "",
    billing_city: "",
    yard_zip: "",
    yard_city: "",
    yard_address: "",
    yard_state: "",
    decal_email: "",
    decal_contact: "",
    decal_cell_number: "",
    decal_address: "",
    decal_zip: "",
    decal_state: "",
    decal_city: "",
  };
  const [tabs, setTabs] = useState({
    one: "active",
    two: "",
    three: "",
  });
  const stateData = [
    // {key:"", value:"Select State"},
    { key: "10", value: "Ten" },
    { key: "20", value: "Twenty" },
    { key: "30", value: "thirty" },
    { key: "40", value: "fourty" },
  ];

  const recaptchaRef = React.createRef();
  function onChange() {
    // console.log("Captcha value:");
  }

  useEffect(() => {
    if (storage.getToken() != null) {
      return navigate(nameBasedProtectedRoutes.dashborad.path);
    }
    getStateList()
      .then((response) => {
        setStates(response?.data);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
      });
  }, [navigate]);

  const onChangeCheckbox = async (
    event: any,
    values: any,
    setFieldValue: any,
    setFieldTouched: any
  ) => {
    setIsChecked(event.target.checked);

    if (event.target.checked === true) {
      setFieldValue("yard_city", values.city, true);
      setFieldValue("yard_address", values.address, true);
      setFieldValue("yard_state", values.state, true);
      setFieldValue("yard_zip", values.zip_code, true);
      setStep2(false);
      await Promise.resolve();
      setStep2(true);
      setFieldTouched("yard_city", true);
    }
  };

  const onChangeCheckboxBilling = async (
    event: any,
    values: any,
    setFieldValue: any,
    setFieldTouched: any
  ) => {
    setIsCheckedBilling(event.target.checked);

    if (event.target.checked === true) {
      setFieldValue(
        "billing_contact_name",
        values.first_name + " " + values.last_name,
        true
      );
      setFieldValue("billing_contact_email", values.email, true);
      setFieldValue("billing_cell_number", values.cell_number, true);
      setFieldValue("billing_city", values.city, true);
      setFieldValue("billing_address", values.address, true);
      setFieldValue("billing_state", values.state, true);
      setFieldValue("billing_zip", values.zip_code, true);
      setStep2(false);
      await Promise.resolve();
      setStep2(true);
      setFieldTouched("billing_city", true);
    }
  };

  const onChangeCheckboxDecal = async (
    event: any,
    values: any,
    setFieldValue: any,
    setFieldTouched: any
  ) => {
    setIsCheckedDecal(event.target.checked);

    if (event.target.checked === true) {
      setFieldValue(
        "decal_contact",
        values.first_name + " " + values.last_name,
        true
      );
      setFieldValue("decal_email", values.email, true);
      setFieldValue("decal_cell_number", values.cell_number, true);
      setFieldValue("decal_city", values.city, true);
      setFieldValue("decal_address", values.address, true);
      setFieldValue("decal_state", values.state, true);
      setFieldValue("decal_zip", values.zip_code, true);
      setStep3(false);
      await Promise.resolve();
      setStep3(true);
      setFieldTouched("decal_city", true);
    }
  };

  const onChangeCaptchaCode = (value: any) => {
    setCaptchaCode(value);
  };

  /**
   * Submit Method to call when user clicks on login button
   * @async
   * @param {string} email
   * @param {string} password
   * @returns {*}
   */
  const handleSubmit = (values: any) => {
    // console.log("values", values)
  };

  const handlePrevious1 = () => {
    setStep3(false);
    setStep2(false);
    setStep1(true);
    setTabs({
      one: "active",
      two: "",
      three: "",
    });
  };
  const handlePrevious2 = () => {
    setStep3(false);
    setStep1(false);
    setStep2(true);
    setTabs({
      one: "prev-step",
      two: "active",
      three: "",
    });
  };
  const handleFirstStep = (
    setFieldTouched: any,
    errors: any,
    setFieldError: any,
    values: any
  ) => {
    setFieldTouched("first_name", true);
    setFieldTouched("last_name", true);
    setFieldTouched("email", true);
    setFieldTouched("company_name", true);
    setFieldTouched("phone", true);
    setFieldTouched("cell_number", true);
    setFieldTouched("address", true);
    setFieldTouched("city", true);
    setFieldTouched("state", true);
    setFieldTouched("zip_code", true);
    setFieldTouched("password", true);
    setFieldTouched("confirm_password", true);

    if (
      !errors.first_name &&
      !errors.last_name &&
      !errors.email &&
      !errors.company_name &&
      !errors.phone &&
      !errors.cell_number &&
      !errors.address &&
      !errors.city &&
      !errors.zip_code &&
      !errors.password &&
      !errors.confirm_password
    ) {
      const email = values.email;
      setLoading(false);
      checkEmailExist({ email })
        .then((response) => {
          setLoading(false);
          setStep1(false);
          setStep2(true);
          setTabs({
            one: "prev-step",
            two: "active",
            three: "",
          });
        })
        .catch((error) => {
          setLoading(false);
          setFieldError("email", error?.response?.data?.message);
          toast.error(error?.response?.data?.message);
        });
    }
  };

  const handleSecondStep = (setFieldTouched: any, errors: any) => {
    setFieldTouched("billing_contact_name", true);
    setFieldTouched("billing_contact_email", true);
    setFieldTouched("billing_cell_number", true);
    setFieldTouched("billing_address", true);
    setFieldTouched("billing_state", true);
    setFieldTouched("billing_city", true);
    setFieldTouched("billing_zip", true);
    setFieldTouched("yard_zip", true);
    setFieldTouched("yard_city", true);
    setFieldTouched("yard_address", true);
    setFieldTouched("yard_state", true);

    if (
      !errors.billing_contact_name &&
      !errors.billing_contact_email &&
      !errors.billing_cell_number &&
      !errors.billing_address &&
      !errors.billing_state &&
      !errors.billing_city &&
      !errors.billing_zip &&
      !errors.yard_zip &&
      !errors.yard_city &&
      !errors.yard_address &&
      !errors.yard_state
    ) {
      setStep2(false);
      setStep3(true);
      setTabs({
        one: "prev-step",
        two: "prev-step",
        three: "active",
      });
      // recaptchaRef.refresh();
    }
  };

  const handleFinalStep = (setFieldTouched: any, errors: any, values: any) => {
    setFieldTouched("decal_contact", true);
    setFieldTouched("decal_email", true);
    setFieldTouched("decal_cell_number", true);
    setFieldTouched("decal_address", true);
    setFieldTouched("decal_city", true);
    setFieldTouched("decal_state", true);
    setFieldTouched("decal_zip", true);
    if (!captchaCode) {
      toast.error(MESSAGES.captchInvalid);
      return;
    }
    if (
      !errors.decal_contact &&
      !errors.decal_email &&
      !errors.decal_cell_number &&
      !errors.decal_address &&
      !errors.decal_city &&
      !errors.decal_state &&
      !errors.decal_zip
    ) {
      
      setLoading(true);
      const formData = values;
      formData["role"] = "CUSTOMER";
      delete formData["confirm_password"];
      userSignUp(formData)
        .then((response) => {
          setLoading(false);
          toast.success(MESSAGES.signUpSuccess);
          navigate(nameBasedRoutes.login.path);
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error?.response?.data?.message);
        });
    }
  };

  return (
    <>
      {" "}
      <Scrollbars className="custome-scroll">
        <Row className="g-0 vh-100 position-relative">
          <Col md={7} className="h-100">
            <div className="h-100 p-4 p-md-4  position-relative ps-lg-0 pe-lg-0   w-100 pb-md-0">
              <Row className="justify-content-center g-0 login-left-inner pb-3">
                <Col lg={10} xl={10} xxl={10}>
                  <div className="mb-2 pb-2">
                    <Link
                      to={nameBasedRoutes.home.path}
                      className="d-inline-block"
                    >
                      <Image
                        className="img-fluid"
                        src={Logo}
                        alt="Logo"
                        width={192}
                        height={40}
                      />
                    </Link>
                  </div>
                  <Row className="mb-4">
                    <Col lg={5} xl={5} xxl={5}>
                      <h1 className="d-inline-block fw-bold h4 mb-1 mt-1 pt-2 w-100">
                        Join HESCO
                      </h1>
                      <h4 className="fs-13 gray-color">
                        Enter the following details
                      </h4>
                    </Col>

                    <Col
                      lg={7}
                      xl={7}
                      xxl={7}
                      className="col-lg-7 col-xl-7 col-xxl-7 d-flex justify-content-center justify-content-lg-end"
                    >
                      <div className={"signup-step " + tabs.one}>
                        <span className="fw-bold">1</span>
                        <div className="fs-13 light-gray-color">
                          Main Contact
                        </div>
                      </div>
                      <div className={"signup-step " + tabs.two}>
                        <span className="fw-bold">2</span>
                        <div className="fs-13 light-gray-color">
                          Billing Contact
                        </div>
                      </div>
                      <div className={"signup-step " + tabs.three}>
                        <span className="fw-bold">3</span>
                        <div className="fs-13 light-gray-color">
                          Decal Contact
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <div className="step1">
                    <Formik
                      validationSchema={SignUpSchema}
                      initialValues={initialValues}
                      onSubmit={handleSubmit}
                    >
                      {({
                        handleSubmit,
                        handleChange,
                        handleBlur,
                        values,
                        errors,
                        touched,
                        setFieldTouched,
                        setFieldValue,
                        setFieldError,
                      }) => (
                        // <Form className="text-start pt-4" noValidate >
                        <>
                          {/* <PermissionsGate
                                                        scopes={[SCOPES.canEdit]}
                                                    > */}
                          {step1 && (
                            <div id="step1">
                              <h2 className="fs-16 fw-bold register-title mb-4">
                                CONTACT INFORMATION
                              </h2>
                              <Row className="">
                                <Col lg={6} xl={6} xxl={6}>
                                  <InputText
                                    controlId="first_name"
                                    label="First name"
                                    placeholder="First name"
                                    touched={touched.first_name}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.first_name}
                                    value={values.first_name}
                                    autofocus
                                  />
                                </Col>
                                <Col lg={6} xl={6} xxl={6}>
                                  <InputText
                                    controlId="last_name"
                                    label="Last name"
                                    placeholder="Last name"
                                    touched={touched.last_name}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.last_name}
                                    value={values.last_name}
                                  />
                                </Col>
                              </Row>
                              <Row className="">
                                <Col lg={6} xl={6} xxl={6}>
                                  <InputText
                                    controlId="email"
                                    label="Email"
                                    placeholder="Email"
                                    touched={touched.email}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.email}
                                    value={values.email}
                                  />
                                </Col>
                                <Col lg={6} xl={6} xxl={6}>
                                  <InputText
                                    controlId="company_name"
                                    label="Company name"
                                    placeholder="Company name"
                                    touched={touched.company_name}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.company_name}
                                    value={values.company_name}
                                  />
                                </Col>
                              </Row>
                              <Row className="">
                                <Col lg={6} xl={6} xxl={6}>
                                  {/*<InputText controlId="phone" label='Phone number' placeholder="Phone number" touched={touched.phone} handleBlur={handleBlur} handleChange={handleChange} errorsField={errors.phone} value={values.phone} />*/}
                                  {/*<InputMask mask="999-999-9999" type="text" name="phone" className={`form-control ${touched.phone && errors.phone ? "is-invalid" : null }`} onChange={handleChange} maskChar={null} label='Phone number' placeholder="Phone number" touched={touched.phone} onBlur={handleBlur}  errorsField={errors.phone} value={values.phone} /> */}
                                  <InputPhoneMask
                                    controlId="phone"
                                    label="Phone number"
                                    placeholder="Phone number"
                                    touched={touched.phone}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.phone}
                                    value={values.phone}
                                    mask="999-999-9999"
                                  />
                                </Col>
                                <Col lg={6} xl={6} xxl={6}>
                                  {/*<InputText controlId="cell_number" label='Cell number' placeholder="Cell number" touched={touched.cell_number} handleBlur={handleBlur} handleChange={handleChange} errorsField={errors.cell_number} value={values.cell_number} />*/}
                                  <InputPhoneMask
                                    controlId="cell_number"
                                    label="Cell number"
                                    placeholder="Cell number"
                                    touched={touched.cell_number}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.cell_number}
                                    value={values.cell_number}
                                    mask="999-999-9999"
                                  />
                                </Col>
                              </Row>
                              <Row className="">
                                <Col lg={6} xl={6} xxl={6}>
                                  <InputText
                                    controlId="address"
                                    label="Address"
                                    placeholder="Address"
                                    touched={touched.address}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.address}
                                    value={values.address}
                                  />
                                </Col>
                                <Col lg={6} xl={6} xxl={6}>
                                  <InputText
                                    controlId="city"
                                    label="City"
                                    placeholder="City"
                                    touched={touched.city}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.city}
                                    value={values.city}
                                  />
                                </Col>
                              </Row>
                              <Row className="">
                                <Col lg={6} xl={6} xxl={6}>
                                  <InputSelect
                                    controlId="state"
                                    label="State/Province"
                                    placeholder="State/Province"
                                    touched={touched.state}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.state}
                                    options={states}
                                    value={values.state}
                                  />
                                </Col>
                                <Col lg={6} xl={6} xxl={6}>
                                  <InputText
                                    controlId="zip_code"
                                    label="Zip"
                                    placeholder="Zip"
                                    touched={touched.zip_code}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.zip_code}
                                    value={values.zip_code}
                                  />
                                </Col>
                              </Row>
                              <Row className="">
                                <Col lg={6} xl={6} xxl={6}>
                                  <InputPassword
                                    controlId="password"
                                    label="Password"
                                    placeholder="Password"
                                    touched={touched.password}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.password}
                                    value={values.password}
                                  />
                                </Col>
                                <Col lg={6} xl={6} xxl={6}>
                                  <InputPassword
                                    controlId="confirm_password"
                                    label="Confirm password"
                                    placeholder="Confirm password"
                                    touched={touched.confirm_password}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.confirm_password}
                                    value={values.confirm_password}
                                  />
                                </Col>
                              </Row>

                              {/* </PermissionsGate> */}
                              <Row>
                                <Col
                                  lg={12}
                                  className="d-flex justify-content-end"
                                >
                                  <Button
                                    className="fw-bold min-width-104"
                                    onClick={() => {
                                      handleFirstStep(
                                        setFieldTouched,
                                        errors,
                                        setFieldError,
                                        values
                                      );
                                    }}
                                    type="button"
                                  >
                                    Next
                                  </Button>
                                </Col>
                              </Row>
                            </div>
                          )}

                          {step2 && (
                            <div id="step2">
                              {/*<h2 className='fs-16 fw-bold register-title mb-4'>BILLING INFORMATION</h2>*/}
                              <Row className="">
                                <Col lg={6} xl={6} xxl={6}>
                                  <h2 className="fs-16 fw-bold register-title mb-4">
                                    BILLING INFORMATION
                                  </h2>
                                </Col>
                                <Col lg={6} xl={6} xxl={6}>
                                  <Form.Group className="mb-3 pb-1">
                                    <Row
                                      xs="auto"
                                      className="align-items-center justify-content-end gx-0"
                                    >
                                      <Col>
                                        <Form.Check
                                          id="rememberCheck1"
                                          checked={isCheckedBilling}
                                          onChange={(e) => {
                                            onChangeCheckboxBilling(
                                              e,
                                              values,
                                              setFieldValue,
                                              setFieldTouched
                                            );
                                          }}
                                          className="fs-15"
                                          type="checkbox"
                                          label="Same as main address"
                                        />
                                      </Col>
                                    </Row>
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row className="">
                                <Col lg={6} xl={6} xxl={6}>
                                  <InputText
                                    controlId="billing_contact_name"
                                    label="Billing contact name"
                                    placeholder="Billing contact name"
                                    touched={touched.billing_contact_name}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.billing_contact_name}
                                    value={values.billing_contact_name}
                                    autofocus
                                  />
                                </Col>
                                <Col lg={6} xl={6} xxl={6}>
                                  <InputText
                                    controlId="billing_contact_email"
                                    label="Billing contact email"
                                    placeholder="Billing contact email"
                                    touched={touched.billing_contact_email}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.billing_contact_email}
                                    value={values.billing_contact_email}
                                  />
                                </Col>
                              </Row>

                              <Row className="">
                                <Col lg={6} xl={6} xxl={6}>
                                  {/*<InputText controlId="billing_cell_number" label='Cell number' placeholder="Cell number" touched={touched.billing_cell_number} handleBlur={handleBlur} handleChange={handleChange} errorsField={errors.billing_cell_number} value={values.billing_cell_number} />*/}
                                  <InputPhoneMask
                                    controlId="billing_cell_number"
                                    label="Cell number"
                                    placeholder="Cell number"
                                    touched={touched.billing_cell_number}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.billing_cell_number}
                                    value={values.billing_cell_number}
                                    mask="999-999-9999"
                                  />
                                </Col>
                                <Col lg={6} xl={6} xxl={6}>
                                  <InputText
                                    disabled={isCheckedBilling}
                                    controlId="billing_address"
                                    label="Address"
                                    placeholder="Address"
                                    touched={touched.billing_address}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.billing_address}
                                    value={values.billing_address}
                                  />
                                </Col>
                              </Row>
                              <Row className="">
                                <Col lg={6} xl={6} xxl={6}>
                                  <InputText
                                    disabled={isCheckedBilling}
                                    controlId="billing_city"
                                    label="City"
                                    placeholder="City"
                                    touched={touched.billing_city}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.billing_city}
                                    value={values.billing_city}
                                  />
                                </Col>
                                <Col lg={6} xl={6} xxl={6}>
                                  <InputSelect
                                    disabled={isCheckedBilling}
                                    controlId="billing_state"
                                    label="State/Province"
                                    placeholder="State/Province"
                                    touched={touched.billing_state}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.billing_state}
                                    value={values.billing_state}
                                    options={states}
                                  />
                                </Col>
                              </Row>
                              <Row className="">
                                <Col lg={6} xl={6} xxl={6}>
                                  <InputText
                                    disabled={isCheckedBilling}
                                    controlId="billing_zip"
                                    label="Zip"
                                    placeholder="Zip"
                                    touched={touched.billing_zip}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.billing_zip}
                                    value={values.billing_zip}
                                  />
                                </Col>
                              </Row>
                              <Row className="">
                                <Col lg={6} xl={6} xxl={6}>
                                  <h2 className="fs-16 fw-bold register-title mb-4">
                                    YARD ADDRESS
                                  </h2>
                                </Col>
                                <Col lg={6} xl={6} xxl={6}>
                                  <Form.Group className="mb-3 pb-1">
                                    <Row
                                      xs="auto"
                                      className="align-items-center justify-content-end gx-0"
                                    >
                                      <Col>
                                        <Form.Check
                                          id="rememberCheck"
                                          checked={isChecked}
                                          onChange={(e) => {
                                            onChangeCheckbox(
                                              e,
                                              values,
                                              setFieldValue,
                                              setFieldTouched
                                            );
                                          }}
                                          className="fs-15"
                                          type="checkbox"
                                          label="Same as main address"
                                        />
                                      </Col>
                                    </Row>
                                  </Form.Group>
                                </Col>
                              </Row>

                              <Row className="">
                                <Col lg={6} xl={6} xxl={6}>
                                  <InputText
                                    disabled={isChecked}
                                    controlId="yard_address"
                                    label="Address"
                                    placeholder="Address"
                                    touched={touched.yard_address}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.yard_address}
                                    value={values.yard_address}
                                  />
                                </Col>
                                <Col lg={6} xl={6} xxl={6}>
                                  <InputText
                                    disabled={isChecked}
                                    controlId="yard_city"
                                    label="City"
                                    placeholder="City"
                                    touched={touched.yard_city}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.yard_city}
                                    value={values.yard_city}
                                  />
                                </Col>
                              </Row>
                              <Row className="">
                                <Col lg={6} xl={6} xxl={6}>
                                  <InputSelect
                                    disabled={isChecked}
                                    controlId="yard_state"
                                    label="State/Province"
                                    placeholder="State/Province"
                                    touched={touched.yard_state}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.yard_state}
                                    value={values.yard_state}
                                    options={states}
                                  />
                                </Col>
                                <Col lg={6} xl={6} xxl={6}>
                                  <InputText
                                    disabled={isChecked}
                                    controlId="yard_zip"
                                    label="Zip"
                                    placeholder="Zip"
                                    touched={touched.yard_zip}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.yard_zip}
                                    value={values.yard_zip}
                                  />
                                </Col>
                              </Row>

                              {/* </PermissionsGate> */}
                              <Row>
                                <Col
                                  lg={12}
                                  className="col-lg-12 d-flex justify-content-between"
                                >
                                  <Button
                                    className="fw-bold min-width-104"
                                    variant="default"
                                    onClick={() => {
                                      handlePrevious1();
                                    }}
                                  >
                                    Previous
                                  </Button>
                                  <Button
                                    className="fw-bold min-width-104"
                                    variant="primary"
                                    onClick={() => {
                                      handleSecondStep(setFieldTouched, errors);
                                    }}
                                    type="button"
                                  >
                                    Next
                                  </Button>
                                </Col>
                              </Row>
                            </div>
                          )}

                          {step3 && (
                            <div id="step3">
                              {/*<h2 className='fs-16 fw-bold register-title mb-4'>DECAL CONTACT INFORMATION</h2>*/}
                              <Row className="">
                                <Col lg={6} xl={6} xxl={6}>
                                  <h2 className="fs-16 fw-bold register-title mb-4">
                                    DECAL CONTACT INFORMATION
                                  </h2>
                                </Col>
                                <Col lg={6} xl={6} xxl={6}>
                                  <Form.Group className="mb-3 pb-1">
                                    <Row
                                      xs="auto"
                                      className="align-items-center justify-content-end gx-0"
                                    >
                                      <Col>
                                        <Form.Check
                                          id="rememberCheck1"
                                          checked={isCheckedDecal}
                                          onChange={(e) => {
                                            onChangeCheckboxDecal(
                                              e,
                                              values,
                                              setFieldValue,
                                              setFieldTouched
                                            );
                                          }}
                                          className="fs-15"
                                          type="checkbox"
                                          label="Same as main address"
                                        />
                                      </Col>
                                    </Row>
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row className="">
                                <Col lg={6} xl={6} xxl={6}>
                                  <InputText
                                    controlId="decal_contact"
                                    label="Decal contact"
                                    placeholder="Decal contact"
                                    touched={touched.decal_contact}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.decal_contact}
                                    value={values.decal_contact}
                                  />
                                </Col>
                                <Col lg={6} xl={6} xxl={6}>
                                  <InputText
                                    controlId="decal_email"
                                    label="Decal contact email"
                                    placeholder="Decal contact email"
                                    touched={touched.decal_email}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.decal_email}
                                    value={values.decal_email}
                                  />
                                </Col>
                              </Row>

                              <Row className="">
                                <Col lg={6} xl={6} xxl={6}>
                                  {/*<InputText controlId="decal_cell_number" label='Cell number' placeholder="Cell number" touched={touched.decal_cell_number} handleBlur={handleBlur} handleChange={handleChange} errorsField={errors.decal_cell_number} value={values.decal_cell_number} />*/}
                                  <InputPhoneMask
                                    controlId="decal_cell_number"
                                    label="Cell number"
                                    placeholder="Cell number"
                                    touched={touched.decal_cell_number}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.decal_cell_number}
                                    value={values.decal_cell_number}
                                    mask="999-999-9999"
                                  />
                                </Col>
                                <Col lg={6} xl={6} xxl={6}>
                                  <InputText
                                    disabled={isCheckedDecal}
                                    controlId="decal_address"
                                    label="Address"
                                    placeholder="Address"
                                    touched={touched.decal_address}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.decal_address}
                                    value={values.decal_address}
                                  />
                                </Col>
                              </Row>
                              <Row className="">
                                <Col lg={6} xl={6} xxl={6}>
                                  <InputText
                                    disabled={isCheckedDecal}
                                    controlId="decal_city"
                                    label="City"
                                    placeholder="City"
                                    touched={touched.decal_city}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.decal_city}
                                    value={values.decal_city}
                                  />
                                </Col>
                                <Col lg={6} xl={6} xxl={6}>
                                  <InputSelect
                                    disabled={isCheckedDecal}
                                    controlId="decal_state"
                                    label="State/Province"
                                    placeholder="State/Province"
                                    touched={touched.decal_state}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.decal_state}
                                    value={values.decal_state}
                                    options={states}
                                  />
                                </Col>
                              </Row>
                              <Row className="">
                                <Col lg={6} xl={6} xxl={6}>
                                  <InputText
                                    disabled={isCheckedDecal}
                                    controlId="decal_zip"
                                    label="Zip"
                                    placeholder="Zip"
                                    touched={touched.decal_zip}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.decal_zip}
                                    value={values.decal_zip}
                                  />
                                </Col>
                              </Row>
                              <Row className="">
                                <Col lg={6} xl={6} xxl={6}>
                                  <ReCAPTCHA
                                    sitekey={process.env.REACT_APP_CPATCHA_KEY}
                                    onChange={onChangeCaptchaCode}
                                    ref={recaptchaRef}
                                  />
                                  <br />
                                </Col>
                              </Row>

                              {/* </PermissionsGate> */}
                              <Row>
                                <Col
                                  lg={12}
                                  className="col-lg-12 d-flex justify-content-between"
                                >
                                  <Button
                                    className="fw-bold min-width-104"
                                    variant="default"
                                    onClick={() => {
                                      handlePrevious2();
                                    }}
                                  >
                                    Previous
                                  </Button>
                                  <Button
                                    className="fw-bold min-width-104"
                                    variant="primary"
                                    onClick={() => {
                                      handleFinalStep(
                                        setFieldTouched,
                                        errors,
                                        values
                                      );
                                    }}
                                    type="button"
                                  >
                                    Submit
                                  </Button>
                                </Col>
                              </Row>
                            </div>
                          )}

                          {/* </Form> */}
                        </>
                      )}
                    </Formik>
                  </div>
                </Col>
              </Row>
              <Row className="bottom-0 g-0 left  row w-100 login-btm pt-3 pb-3 text-center ">
                <Col lg={12} xl={12} xxl={12}>
                  <Col lg={12}>
                    <h6 className="mb-0 fs-11 gray-color">
                      Already have an account?
                    </h6>
                  </Col>
                  <Col lg={12}>
                    <Link
                      className="fw-bold text-decoration-none fs-13"
                      to={nameBasedRoutes.login.path}
                    >
                      Login
                    </Link>
                  </Col>
                </Col>
              </Row>
            </div>
          </Col>
          <Col
            md={5}
            className="mobileBannerActive h-100 position-fixed right-0"
          >
            <Image
              className="h-100  w-100"
              src={RegisterBanner}
              alt="Login Banner"
            />
            <div className="bottom-0 h4 pb-3 position-absolute pt-3 w-100 white-color text-center posti right-text-overlapp mb-0">
              CRANE SAFETY EXPERTS
            </div>
          </Col>
        </Row>
      </Scrollbars>
      <Loader isLoading={loading} />
    </>
  );
};
